/** Maintains recently viewed product IDs for Horizon and lightweight card details for Hadeva. */
export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #DETAILS_KEY = 'viewedProductDetails';
  static #MAX_PRODUCTS = 8;

  static addProduct(productId, details = null) {
    const id = String(productId);
    let viewedProducts = this.getProducts().map(String).filter((savedId) => savedId !== id);
    viewedProducts.unshift(id);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);
    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));

    if (details && typeof details === 'object') {
      let savedDetails = this.getProductDetails().filter((item) => String(item.id) !== id);
      savedDetails.unshift({
        id,
        title: String(details.title || ''),
        url: String(details.url || ''),
        image: String(details.image || ''),
        price: String(details.price || ''),
      });
      localStorage.setItem(this.#DETAILS_KEY, JSON.stringify(savedDetails.slice(0, this.#MAX_PRODUCTS)));
    }
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
    localStorage.removeItem(this.#DETAILS_KEY);
  }

  static getProducts() {
    try { return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]'); } catch (_) { return []; }
  }

  static getProductDetails() {
    try { return JSON.parse(localStorage.getItem(this.#DETAILS_KEY) || '[]'); } catch (_) { return []; }
  }
}
